import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import {
  Menu,
  MenuItem,
  Sidebar as SidebarCustom,
  sidebarClasses,
  SubMenu,
} from "react-pro-sidebar";

import { useResize } from "../../../hooks/useResize";
import { toggleBurgerStatement } from "../../../redux/viewReducer/viewActions";
import { sidebarSettings, menuItemStyles } from "./sidebarSettings";

import styles from "./Sidebar.module.css";

export default function Sidebar() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [openKeys, setOpenKeys] = useState([]);
  const [isLogin, setIsLogin] = useState("");
  const [activeItem, setActiveItem] = useState("");

  const { burgerState } = useSelector((state) => state.viewReducer);
  const { sortedMenuNames } = useSelector(
    (state) => state.roleControllerReducer,
  );
  const { availableChapters } = useSelector(
    (state) => state.roleManagementReducer,
  );
  const { isTablet, isNetbook } = useResize();

  const showMainItem = (elementData) => {
    if (elementData && sortedMenuNames && availableChapters) {
      return elementData.listModal.some((modal) => {
        if (modal.show) {
          const id = sortedMenuNames[modal.show]?.id;
          return availableChapters.some((chapter) => chapter.chapterId === id);
        }
        return false;
      });
    } else {
      return false;
    }
  };

  const showChildItem = (chapterName) => {
    if (sortedMenuNames && availableChapters) {
      const matchingObject = availableChapters.find((item) => {
        return item.chapterId === sortedMenuNames[chapterName]?.id;
      });

      return !!matchingObject;
    } else {
      return false;
    }
  };

  const switchBurgerState = () => {
    isTablet && dispatch(toggleBurgerStatement());
  };

  const handleMenuItemClick = (itemId) => {
    setActiveItem(itemId);
    localStorage.setItem("activeSidebarItem", itemId);
    switchBurgerState();
  };

  const handleSubMenuClick = (parentId) => {
    setOpenKeys((prevOpenKeys) => {
      if (prevOpenKeys.includes(parentId)) {
        return prevOpenKeys.filter((key) => key !== parentId);
      }
      return [...prevOpenKeys, parentId];
    });
  };

  useEffect(() => {
    burgerState && isTablet
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "initial");
  }, [burgerState, isTablet]);

  useEffect(() => {
    window.location.href.includes("login")
      ? setIsLogin("login")
      : setIsLogin("");
  }, [window.location.pathname]);

  useEffect(() => {
    const storedItem = localStorage.getItem("activeSidebarItem");
    if (storedItem) {
      setActiveItem(storedItem);
      const parentItem = findParentItem(storedItem);
      if (parentItem) {
        setOpenKeys((prevOpenKeys) => [...prevOpenKeys, parentItem]);
      }
    }
  }, []);

  const findParentItem = (itemId) => {
    for (const item of sidebarSettings) {
      if (item.listModal.some((subItem) => subItem.id === itemId)) {
        return item.id;
      }
    }
    return null;
  };

  useEffect(() => {
    const parentItem = findParentItem(location.pathname.split("/")[1]);
    if (parentItem) {
      setOpenKeys((prevOpenKeys) => [...prevOpenKeys, parentItem]);
    } else {
      setOpenKeys([]);
    }
  }, [location.pathname]);

  return (
    <div className={styles[isTablet ? "" : "sidebar-container"]}>
      <SidebarCustom
        customBreakPoint="1199px"
        toggled={burgerState}
        onBackdropClick={switchBurgerState}
        rootStyles={{
          [`.${sidebarClasses.container}`]: {
            fontFamily: "RobotoRegular",
            fontSize: "16px",
            fontWeight: "500",
            lineHeight: "21px",
            letterSpacing: "0px",
            textAlign: "left",
            color: "#233E5A",
            userSelect: "none",
            scrollbarWidth: "none",
            paddingLeft: isNetbook ? "8px" : "16px",
            paddingTop: isTablet ? "170px" : "0",
            paddingBottom: isTablet ? "16px" : "0",
          },
        }}
        width={isNetbook ? "240px" : "360px"}
        backgroundColor="#E4F0FD"
        hidden={isLogin === "login" ? true : false}
      >
        <Menu menuItemStyles={menuItemStyles} openKeys={openKeys}>
          {sidebarSettings.map((item) =>
            item.listModal.length > 0
              ? showMainItem(item) && (
                  <SubMenu
                    open={openKeys.includes(item.id)}
                    key={item.id}
                    label={item.title}
                    title={item.title}
                    onClick={() => handleSubMenuClick(item.id)}
                  >
                    {item.listModal.map(
                      (elem) =>
                        showChildItem(elem.show) && (
                          <MenuItem
                            key={elem.id}
                            component={
                              <NavLink
                                to={`/${elem.id}`}
                                className={styles.sidebar_navlink}
                                onClick={() => handleMenuItemClick(item.id)}
                              />
                            }
                          >
                            {elem.title}
                          </MenuItem>
                        ),
                    )}
                  </SubMenu>
                )
              : showChildItem(item.show) && (
                  <MenuItem
                    key={item.id}
                    component={
                      <NavLink
                        to={`/${item.id}`}
                        className={styles.sidebar_menuitem}
                        onClick={() => handleMenuItemClick(item.id)}
                      />
                    }
                    className={styles.sidebar_navlink_main}
                  >
                    {item.title}
                  </MenuItem>
                ),
          )}
        </Menu>
      </SidebarCustom>
    </div>
  );
}
